import React, { useState } from 'react'
import whyChooseUsData from '../../api/whyChooseUs'
import './../../sass/page/_why-choose-us.scss'


const WhyChooseUs = (props) => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <section id="why-choose-us" className={`wpo-service-section-s2 section-padding ${props.sClass}`}>
            <div className="container">
                <div className="row align-items-center justify-content-center">
                    <div className="col-lg-5">
                        <div className="wpo-section-title">
                            <h2>Why Choose Us</h2>
                            <p>At Jagruti Chemicals, we deliver high-quality chemicals with reliability and timely service. Our expertise and customer-first approach make us a trusted partner for industries across India.</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {whyChooseUsData.map((item, index) => (
                        <div className="col-lg-4 col-md-6 col-12" key={index}>
                            <div 
                                className={`wpo-service-item ${hoveredIndex === index ? 'hovered' : ''}`}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                            >
                                <div className="wpo-service-img">
                                    {typeof item.icon === 'string' ? (
                                        <span className="why-choose-us-emoji">{item.icon}</span>
                                    ) : (
                                        <span className="why-choose-us-icon">{item.icon}</span>
                                    )}
                                </div>
                                <div className="wpo-service-text">
                                    <h2>{item.title}</h2>
                                    <p>{item.description}</p>
                                </div>
                                <div className="visible-icon">
                                    {typeof item.icon === 'string' ? (
                                        <span className="why-choose-us-emoji">{item.icon}</span>
                                    ) : (
                                        <span className="why-choose-us-icon">{item.icon}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default WhyChooseUs;